module.exports = __webpack_public_path__ + "static/media/14_2.e2c3f558.jpg";